export type PathParam = Record<string, string | number>;

export interface PathUtil<PathParam = unknown> {
  fullPath: string[];
  relativePath: string[];
  generate(params?: PathParam): string[];
}

type Path =
  | 'landing'
  | 'about-us'
  | 'terms-and-conditions'
  | 'privacy-policy'
  | 'blog'
  | 'blog/:id'
  | 'contact-us'
  | 'email-unsubscribe'
  | 'chart/:id'
  | 'back-to-stock'
  | 'help'
  | 'help/:slug';

export const Path: Record<Path, Path> = {
  landing: 'landing',
  'about-us': 'about-us',
  'terms-and-conditions': 'terms-and-conditions',
  'privacy-policy': 'privacy-policy',
  blog: 'blog',
  'blog/:id': 'blog/:id',
  'contact-us': 'contact-us',
  'email-unsubscribe': 'email-unsubscribe',
  'chart/:id': 'chart/:id',
  'back-to-stock': 'back-to-stock',
  help: 'help',
  'help/:slug': 'help/:slug',
};

export class RoutePath {
  private static _paths: Record<Path, PathUtil> = {
    landing: {
      fullPath: [''],
      relativePath: [''],
      generate: () => [''],
    },
    'about-us': {
      fullPath: ['/about-us'],
      relativePath: ['about-us'],
      generate: () => ['/about-us'],
    },
    'terms-and-conditions': {
      fullPath: ['/terms-and-conditions'],
      relativePath: ['terms-and-conditions'],
      generate: () => ['/terms-and-conditions'],
    },
    'privacy-policy': {
      fullPath: ['/privacy-policy'],
      relativePath: ['privacy-policy'],
      generate: () => ['/privacy-policy'],
    },
    blog: {
      fullPath: ['/blog'],
      relativePath: ['blog'],
      generate: () => ['/blog'],
    },
    'blog/:id': {
      fullPath: ['/', 'blog', ':id'],
      relativePath: ['blog', ':id'],
      generate: ({ id }: { id: string }) => ['/', 'blog', id],
    },
    'contact-us': {
      fullPath: ['/contact-us'],
      relativePath: ['contact-us'],
      generate: () => ['/contact-us'],
    },
    'email-unsubscribe': {
      fullPath: ['/email-unsubscribe'],
      relativePath: ['email-unsubscribe'],
      generate: () => ['/email-unsubscribe'],
    },
    'chart/:id': {
      fullPath: ['/', 'chart', ':id'],
      relativePath: ['chart', ':id'],
      generate: ({ id }: ChartPageParams) => ['/', 'chart', id],
    },
    'back-to-stock': {
      fullPath: ['/', 'back-to-stock'],
      relativePath: ['back-to-stock'],
      generate: () => ['/', 'back-to-stock'],
    },
    help: {
      fullPath: ['/', 'help'],
      relativePath: ['help'],
      generate: () => ['/', 'help'],
    },
    'help/:slug': {
      fullPath: ['/', 'help', ':slug'],
      relativePath: ['help', ':slug'],
      generate: ({ slug }: HelpArticlePageParams) => ['/', 'help', slug],
    },
  };

  static getPath<T extends PathParam>(path: Path): PathUtil<T> {
    if (!this._paths[path as Path]) throw new Error('Path not defined');

    return this._paths[path as Path];
  }
}

export interface ChartPageParams extends PathParam {
  id: string;
}

export interface HelpArticlePageParams extends PathParam {
  slug: string;
}
